import styled from 'styled-components';

export default styled.div`
	display: flex;
	align-items: center;
	.btn-wrapper {
		display: flex;
		padding: var(--spacing-small);
	}

	.group-input-textbox {
		width: 30rem;
		.motif-input {
			padding: 2rem 0.5rem 0.8rem 1rem;
		}
	}
`;
